import styled from 'styled-components';
export const Container = styled.div``;
export const Label = styled.p`
  ${_ref => {
  let {
    theme
  } = _ref;
  return theme.fonts.labelMD;
}}
  color: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.neutralL5;
}};
  margin: 0;
  margin-bottom: 12px;
`;
export const RadiosContainer = styled.div`
  display: grid;
  grid-template-columns: ${_ref3 => {
  let {
    cols
  } = _ref3;
  return `repeat(${cols}, 1fr)`;
}};
  grid-gap: 2px 0;
`;
export const Gutter = styled.div`
  height: 22px;
`;